import { render, staticRenderFns } from "./company-data.vue?vue&type=template&id=4e37bccc&scoped=true&"
import script from "./company-data.vue?vue&type=script&lang=js&"
export * from "./company-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e37bccc",
  null
  
)

export default component.exports